/**
 * This custom hook provides the functionality to retrieve users to be shown in the UI.
 */

import {useContext, useEffect, useState} from "react";
import {FirebaseAuthContext} from "../../../../commons/firebase/FirebaseAuthProvider";
import {useSnackbar} from "notistack";
import {useIntl} from "react-intl";

const useLoadUser = (uid) => {

    const [user, setUser] = useState()
    const [loading, setLoading] = useState(true)

    const {signedInUser} = useContext(FirebaseAuthContext);
    const {enqueueSnackbar} = useSnackbar();

    // Internationalization for simple strings
    const intl = useIntl();

    // Retrieving the fresh user data
    const fetchUserData = async () => {
        const idToken = await signedInUser.getIdToken()
        let userPromise

        if (uid) {
            userPromise = fetch('/reg-main/users/' + uid + '?idToken=' + idToken)
        } else {
            userPromise = fetch('/reg-main/profile?idToken=' + idToken)
        }

        return userPromise.then(async (data) => {
            // Throw an error including the textual status of the HTTP response code (no detailed message necessary)
            if (data.status !== 200) {
                throw new Error((await data.json()).status)
            }

            const userJson = await data.json();
            setUser(userJson)
        }).catch((error) => {
            enqueueSnackbar(
                intl.formatMessage({
                    id: 'app.users.messages.load.user.error',
                    defaultMessage: 'Something went wrong while loading the user: {error}'
                }, {error: error.message}), {
                    variant: 'error',
                    preventDuplicate: true,
                    autoHideDuration: 5000
                });
        }).finally(() => {
            setLoading(false)
        })
    }

    useEffect(() => {
        fetchUserData()
    }, [])


    return {
        loading,
        user
    }
}
export default useLoadUser;